import { Routes } from 'common/routeConfig'
import StaticPageWrapper from 'components/staticPage/StaticPageWrapper'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useParseHTML } from 'utils/hooks/use-parse-html'

type StaticPageProps = {
    page: keyof typeof StaticPages
    withTitle?: boolean
}

enum StaticPages {
    'terms' = 'terms-of-use',
    'privacy' = 'privacy-policy',
    'disclaimer' = 'disclaimer',
    'manual' = 'manual'
}

const StaticPage: React.FC<StaticPageProps> = ({ page, withTitle }) => {
    const [htmlContent, setHtmlContent] = useState<string | null>(null)
    const navigate = useNavigate()

    useEffect(() => {
        async function fetchHtmlContent() {
            try {
                const response = await fetch(
                    `./assets/static/${StaticPages[page]}.html`
                )
                const html = await response.text()
                setHtmlContent(html)
            } catch (error) {
                navigate(Routes.NOT_FOUND)
                console.error('Error fetching HTML content:', error)
            }
        }

        fetchHtmlContent()
    }, [navigate, page])

    const parsedHTML = useParseHTML(htmlContent)
    const { t } = useTranslation('pages')

    return (
        <StaticPageWrapper
            isContentPage
            title={withTitle ? t(`${page}.title`) : undefined}
        >
            {parsedHTML}
        </StaticPageWrapper>
    )
}

export default StaticPage
